
import React from 'react';
import ReactMarkdown from 'react-markdown';

import { animateScroll } from 'react-scroll';

import resumeMarkDown from './resume.md';

import './resume.css';

import app from './index';

export default class Resume extends React.Component {
  componentDidMount() {
    animateScroll.scrollToTop();
  }

  render() {
    return (
      // React Markdown disregards id (use className if injecting style directly
      //   to the markdown component.
      <div id="resume">
        <a href={ app.deployPath }>Back to portfolio</a>
        <hr />
        <ReactMarkdown source={resumeMarkDown} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app_data/Resume.js